import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuard } from './auth.guard';
import { AuthService } from './services/auth.service';
import { AccountContextService } from './services/account-context.service';
import { AuthCallbackComponent } from './auth-callback.component';
import { LogoutCallbackComponent } from './logout-callback.component';

@NgModule({
  declarations: [
    AuthCallbackComponent,
    LogoutCallbackComponent
  ],
  imports: [
    ReactiveFormsModule,
    OAuthModule.forRoot(),
    HttpClientModule
  ],
  providers: [
    AccountContextService,
    AuthService,
    AuthGuard
  ]
})
export class AuthModule { }
